export default "__VITE_ASSET__T3kSzy1O__"